/**
 * Showcase API client — talks to /api/showcase/* endpoints on the same origin.
 * Credentials included so the httpOnly session cookie flows on subsequent requests.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

async function request(path, { method = "GET", body = null, signal = null } = {}) {
  const url = `${BACKEND_URL}${path}`;
  const init = {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    signal,
  };
  if (body !== null) init.body = JSON.stringify(body);

  const res = await fetch(url, init);
  const text = await res.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (e) {
      data = { detail: text };
    }
  }
  if (!res.ok) {
    const err = new Error((data && data.detail) || `Request failed (${res.status})`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const showcaseApi = {
  health: () => request("/api/showcase/health"),
  whoami: () => request("/api/showcase/whoami"),
  login: (password) => request("/api/showcase/login", { method: "POST", body: { password } }),
  logout: () => request("/api/showcase/logout", { method: "POST" }),
  overview: () => request("/api/showcase/overview"),
  product: (slug) => request(`/api/showcase/product/${encodeURIComponent(slug)}`),
  pin: () => request("/api/showcase/pin", { method: "POST" }),
  clearPin: () => request("/api/showcase/pin", { method: "DELETE" }),
  notes: () => request("/api/showcase/notes"),
  addNote: (payload) => request("/api/showcase/note", { method: "POST", body: payload }),
  hiddenItems: () => request("/api/showcase/hidden"),
  hideItem: (itemKey, productSlug) => request("/api/showcase/hidden", { method: "POST", body: { item_key: itemKey, product_slug: productSlug || null } }),
  restoreItem: (id) => request(`/api/showcase/hidden/${encodeURIComponent(id)}`, { method: "DELETE" }),
  descriptions: () => request("/api/showcase/descriptions"),
  saveDescription: (slug, tagline, expectedVersion) => request(`/api/showcase/descriptions/${encodeURIComponent(slug)}`, {
    method: "PUT", body: { tagline, expected_version: expectedVersion },
  }),
  resetDescription: (slug, expectedVersion) => request(`/api/showcase/descriptions/${encodeURIComponent(slug)}`, {
    method: "DELETE", body: { expected_version: expectedVersion },
  }),
  deleteNote: (id) => request(`/api/showcase/note/${encodeURIComponent(id)}`, { method: "DELETE" }),
};

export default showcaseApi;
